import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import Select from 'react-select';
import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

export const SelectContainer = styled('div', { label: 'SelectContainer' })`
    margin-bottom: 8px;
`;

interface NewSelectPropsType {
    variant: DefaultComponentVariantType | null;
    hideIndicator?: boolean; 
}

const setNewSelect = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            .react-select__control {
                border-radius: ${theme.star.radius.small};
            }
            .react-select__menu {
                border-radius: ${theme.star.radius.small};
                overflow: hidden;
            }
        `;
    }
    return css``;
};

export const NewSelect = withConfig(theme => styled(Select, { label: 'NewSelect' })<NewSelectPropsType>`
    ${({ variant }): SerializedStyles => setNewSelect(variant, theme)};
    .react-select__control {
        border: 0;
        border-radius: 0;
        background: ${theme.star.form.light.bgColor};
        color: ${theme.star.form.light.txtColor};
        height: 40px;
    }

    .react-select__indicator-separator {
        display: none;
        margin: 0;
    }

    .react-select__control--is-focused {
        box-shadow: none;
    }

    .react-select__indicator, .react-select__indicator:hover  {
        color: ${theme.star.form.bgColor};
        padding: 8px 16px;
        display: ${({ hideIndicator }): string => hideIndicator === true ? 'none' : 'block'};
    }

    .react-select__menu {
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.32);
        border-radius: 0;
        color: ${theme.star.form.txtColor};
    }

    .react-select__option--is-selected,
    .react-select__option--is-focused  {
        background-color: ${theme.star.form.bgColorQuaternary};
        color: ${theme.star.form.txtColorQuaternary};
    }

    .react-select__option{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 32px;
    }

    .react-select__menu-list {
        padding: 0;
    }
`);

export const CheckIcon = styled(CheckSingleIcon, { label: 'CheckIcon' })`
    fill: currentcolor;
    width: 12px;
`;

export const SelectIcon = styled(ChevronIcon, { label: 'SelectIcon' })`
    width: 12px;
`;
